// https://www.showdoc.cc/2087602083713144
// H3ingUjN

// http://shuion-new.netime.com.cn/admin/
// admin admin

const host = '/api/';

export default {
    host,
    config: `${host}index`,
    detail: `${host}info`,
    list: `${host}list`,
    photo: `${host}honour`,
    repair: `${host}repair`,
    repairDetail: `${host}repair-info`,
    contact: `${host}contact`,
    message: `${host}message-menu`,
    upMessage: `${host}message`,
}